
/**
 * Utility functions for handling localStorage
 */

export const saveToLocalStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getFromLocalStorage = (key: string) => {
  const value = localStorage.getItem(key);
  if (value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error('Error parsing JSON from localStorage:', error);
      return null;
    }
  }
  return null;
};

export const getFilteredData = (key: string, filters: {
  startDate?: Date,
  endDate?: Date,
  searchTerm?: string,
  filterField?: string,
  filterValue?: string
}) => {
  let data = getFromLocalStorage(key) || [];
  
  // Apply date filtering
  if (filters.startDate && filters.endDate) {
    data = data.filter((item: any) => {
      const itemDate = new Date(item.date || item.subscribeDate || item.createdAt);
      return itemDate >= filters.startDate! && itemDate <= filters.endDate!;
    });
  }
  
  // Apply search term filtering
  if (filters.searchTerm) {
    const searchLower = filters.searchTerm.toLowerCase();
    data = data.filter((item: any) => {
      // Search in common fields
      return Object.values(item).some(value => 
        typeof value === 'string' && value.toLowerCase().includes(searchLower)
      );
    });
  }
  
  // Apply specific field filtering
  if (filters.filterField && filters.filterValue) {
    data = data.filter((item: any) => {
      return item[filters.filterField!] === filters.filterValue;
    });
  }
  
  return data;
};
